import PeerGroupAnalysis from "pages/underwriters/components/peerGroupAnalysis";

export default function UnderwriterInsightsPGA() {
  return (
    <PeerGroupAnalysis
      step={0}
      isMobile={false}
      setOpenSuccessPopup={() => {}}
    />
  );
}
